@use '../../../../styles/Constants.scss' as Constants;
@use '../../../../styles/Colors.scss' as Colors;

.dropdown-cell {
	width: 100%;
	max-width: 100%;
	height: 100% !important;
	font-size: Constants.$val-fontSizeSmall !important;

	&.bold {
		:global(.dropdown-menu__selected-text) {
			font-weight: bold;	
		}
	}

	:global(.dropdown-menu__selected) {
		display: flex;
		align-items: center;
		justify-content: space-between;
		text-align: left;
		cursor: pointer;
		font-size: Constants.$val-fontSizeSmall !important;
	}
	
	:global(.dropdown-menu__selected-text) {
		flex: 1 1 auto;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	:global(.dropdown-menu__with-caret) {
		flex: 0 0 auto;
		margin-right: 8px; /* optional spacing from text */
	}

	&:has(div > :global(.dropdown)) {
		height: 100% !important;
	}

	:global(.dropdown) {
		height: 100% !important;
	}

	:global(.dropdown-toggle) {
		height: 100% !important;
	}

	:global(.dropdown-cell .dropdown-menu) {
		z-index: 9999 !important;
		height: 100% !important;
	}

	& :global(.dropdown-menu__with-caret) {
		margin-left: Constants.$val-spacing-s;
		margin-left: auto;
		margin-right: 0px !important;
		color: black;
	}
	  
	:global(.dropdown-toggle--bordered) {
		border-radius: 0% !important;
	}

}

.error-wrapper :global(.dropdown ) {
	color: Colors.$col-red !important; 
	background-color: Colors.$col-redBackground !important;
}

.error-wrapper :global(.dropup ) {
	color: Colors.$col-red !important; 
	background-color: Colors.$col-redBackground !important;
}

.error-wrapper :global(.dropdown-menu__selected) {
	color: Colors.$col-red !important; 
	background-color: Colors.$col-redBackground !important;
}
